import React from 'react';
import Link from 'react-router';
import Moment from 'react-moment';
import { browserHistory } from 'react-router';
import { Meteor } from 'meteor/meteor';

import { Roles } from 'roles';

import {
	Button
} from '@sketchpixy/rubix';

import flattenObject from '../../helpers/flattenObject';

export default class MgfRowComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};

	}

	delete() {
		const collectionFile = require('../../collections/' + this.props.type + '/' + this.props.type);
		
		if (collectionFile.default)
			collectionFile.default.remove({_id: this.props.item._id});
	}

	edit() {
		this.context.router.push('/' + this.props.type + '/' + this.props.item._id);
	}

	view() {
		this.context.router.push('/' + this.props.type + '/' + this.props.item._id + '/view');
	}

	renderColumns() {
		let flatten = flattenObject(this.props.item);
		return _.map(this.props.fields, (field, key) => (
			<td key={key}>
				{field.type === Date &&
					<Moment format="DD/MM/YYYY">{ flatten[key] }</Moment>}
				{(field.type === String || field.type === Number) && (field.uniforms && field.uniforms.transform) &&
					field.uniforms.transform(flatten[key]) }
				{(field.type === String || field.type === Number) && !(field.uniforms && field.uniforms.transform) &&
					flatten[key] }
			</td>
		));
	}

	render() {
		return (
			<tr>
				{this.renderColumns()}		
				<td>
					{ (Roles.userHasPermission(Meteor.userId(), this.props.type + '.view', Meteor.userId(), this.props.item)) &&
						<Button bsStyle="primary" onClick={this.view.bind(this)}>Voir</Button> }
						&nbsp;&nbsp;
					{ (Roles.userHasPermission(Meteor.userId(), this.props.type + '.update', Meteor.userId(), this.props.item)) &&
						<Button bsStyle="warning" onClick={this.edit.bind(this)}>Modifier</Button> }
						&nbsp;&nbsp;
					{ (Roles.userHasPermission(Meteor.userId(), this.props.type + '.update', Meteor.userId(), this.props.item)) &&
						<Button bsStyle="danger" onClick={this.delete.bind(this)}>Supprimer</Button> }
				</td>
			</tr>
		);
	}

}

MgfRowComponent.propTypes = {
	item: React.PropTypes.object.isRequired,
	fields: React.PropTypes.object.isRequired,
	type: React.PropTypes.string.isRequired,
};

MgfRowComponent.contextTypes = {
	router: React.PropTypes.object.isRequired
};


/** WEBPACK FOOTER **
 ** ./src/universal/components/common/mgfRow.js
 **/